/**
 * CategoryCardItem - Single category card
 *
 * Layout matches legacy tools.store.ro spec:
 * - Square card (aspect-square)
 * - Image fills the entire card
 * - Title is an absolute orange "tab" anchored at bottom-left, with the right
 *   edge rounded (border-radius: 0 200px 200px 0)
 * - White 2px border that darkens on hover (reserves layout space)
 */

import { useCategoryCardsVariants } from '../../../Theme'
import { safeHref } from '../../lib'

import type { HomepageCategoryCard } from '../../types'

interface CategoryCardItemProps {
  card: HomepageCategoryCard
  /** Resolved URL for category link type */
  resolvedUrl: string | undefined
}

export function CategoryCardItem({ card, resolvedUrl }: CategoryCardItemProps) {
  const {
    categoryCardItemVariants,
    categoryCardImageVariants,
    categoryCardTitleVariants,
  } = useCategoryCardsVariants()

  const href =
    card.link_type === 'category'
      ? safeHref(resolvedUrl)
      : safeHref(card.link_value)

  if (!href) return null

  return (
    <a href={href} className={categoryCardItemVariants()}>
      {card.image ? (
        <img
          src={card.image}
          alt={card.title || ''}
          width={400}
          height={400}
          className={categoryCardImageVariants()}
          loading="lazy"
        />
      ) : (
        <div className="w-full h-full bg-cards-bg flex items-center justify-center">
          <span className="text-second-btn-bg text-sm">No image</span>
        </div>
      )}

      {card.title && (
        <span className={categoryCardTitleVariants()}>{card.title}</span>
      )}
    </a>
  )
}
